/**
 * @generated SignedSource<<525f2a19557448dc601731b1166573e2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetTeamScheduleContentDaily_WidgetTeamScheduleContentDaily$data = {
  readonly dailyTeamSchedule: {
    readonly events: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"useNowIndexes_teamScheduleEventOccasion">;
    }>;
    readonly " $fragmentSpreads": FragmentRefs<"WidgetTeamScheduleContentList_teamSchedule" | "WidgetTeamScheduleContentSectionHeader_teamSchedule">;
  };
  readonly " $fragmentType": "WidgetTeamScheduleContentDaily_WidgetTeamScheduleContentDaily";
};
export type WidgetTeamScheduleContentDaily_WidgetTeamScheduleContentDaily$key = {
  readonly " $data"?: WidgetTeamScheduleContentDaily_WidgetTeamScheduleContentDaily$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTeamScheduleContentDaily_WidgetTeamScheduleContentDaily">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetTeamScheduleContentDaily_WidgetTeamScheduleContentDaily",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TeamSchedule",
      "kind": "LinkedField",
      "name": "dailyTeamSchedule",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetTeamScheduleContentList_teamSchedule"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetTeamScheduleContentSectionHeader_teamSchedule"
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "includeInlineRoutines",
              "value": true
            }
          ],
          "concreteType": null,
          "kind": "LinkedField",
          "name": "events",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "useNowIndexes_teamScheduleEventOccasion"
            }
          ],
          "storageKey": "events(includeInlineRoutines:true)"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WidgetTeamScheduleContentDaily",
  "abstractKey": null
};

(node as any).hash = "26dd08112eec0207039c9776c1fd8774";

export default node;
